import { useGetCompanyById } from '@sit/client-shared';
import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';
import { Outlet } from 'react-router';
import GoBackButton from '../../components/GoBackButton';
import { CompanyNavigationBar } from './CompanyNavigationBar';
import { useCompanyTreeSettingsIdInPathParams } from './helpers';

export function CompanyPage() {
  const companyTreeSettingsId = useCompanyTreeSettingsIdInPathParams();
  const {
    data: company,
    isPending,
    error,
  } = useGetCompanyById({
    companyTreeSettingsId,
  });

  return (
    <div className="intacct-admin">
      <Box display="flex">
        <GoBackButton url="/companies" width="auto" />
        <Typography variant="h1">
          {error
            ? error.message
            : `Company - ${isPending ? 'Loading...' : company.externalId}`}
        </Typography>
      </Box>
      <div id="sticky-container" style={{ height: '100px' }}>
        <CompanyNavigationBar />
        <div className="intacct-admin-inner-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
